<div class="note-dialog">

  <!-- ADD MODE -->
  <ng-container *ngIf="mode === 'add'">
    <div class="dialog-header">
      <div>
        <h2 class="dialog-title">Add Notes</h2>
        <p class="dialog-subtitle">Add one or more notes for this case</p>
        <!-- <p class="dialog-subtitle">Add one or more notes for this case{{ caseTitle ? ' — ' + caseTitle : '' }}.</p> -->
      </div>
      <button type="button" class="dialog-close-btn" (click)="cancel()" aria-label="Close dialog">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="note-input-list-toolbar">
      <button type="button" class="add-another-link" (click)="addAnotherNote()">
        <i class="fa fa-plus" aria-hidden="true"></i> Add Another Note
      </button>
    </div>
    <div class="note-input-list">
      <div class="note-input-row" *ngFor="let note of noteInputs; let i = index; trackBy: trackByIndex">
        <div class="note-input-head">
          <span class="note-input-label">Note {{ i + 1 }}</span>
          <button type="button" class="remove-note-btn" *ngIf="noteInputs.length > 1"
                  (click)="removeNote(i)" [attr.aria-label]="'Remove note ' + (i + 1)">
            <i class="fa fa-trash-o" aria-hidden="true"></i> Remove
          </button>
        </div>
        <textarea class="note-textarea" rows="3"
                  [ngModel]="noteInputs[i]" (ngModelChange)="onNoteChange(i, $event)"
                  [class.has-error]="showNoteError(i)"
                  [attr.aria-invalid]="showNoteError(i)"
                  [attr.aria-describedby]="showNoteError(i) ? ('note-error-' + i) : null"
                  placeholder="Type a note…"></textarea>
        <div class="note-input-foot">
          <p class="field-error" *ngIf="showNoteError(i)" [id]="'note-error-' + i">Please enter a note.</p>
          <p class="word-counter" [class.limit-reached]="wordCount(noteInputs[i]) >= maxWords">{{ wordCount(noteInputs[i]) }} / {{ maxWords }} words</p>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="btn-save" (click)="saveNotes()">Save Notes</button>
    </div>
  </ng-container>

  <!-- EDIT MODE -->
  <ng-container *ngIf="mode === 'edit'">
    <div class="dialog-header">
      <h2 class="dialog-title">Edit Note</h2>
      <button type="button" class="dialog-close-btn" (click)="cancel()" aria-label="Close dialog">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="note-input-row">
      <textarea class="note-textarea" rows="4" [(ngModel)]="editContent"
                [class.has-error]="showEditError"
                [attr.aria-invalid]="showEditError"
                [attr.aria-describedby]="showEditError ? 'edit-note-error' : null"
                placeholder="Type a note…"></textarea>
      <div class="note-input-foot">
        <p class="field-error" *ngIf="showEditError" id="edit-note-error">Please enter a note.</p>
        <p class="word-counter">{{ wordCount(editContent) }} / {{ maxWords }} words</p>
      </div>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="btn-save" (click)="saveEdit()">Save Changes</button>
    </div>
  </ng-container>

  <!-- VIEW MODE (read-only full note text) -->
  <ng-container *ngIf="mode === 'view'">
    <div class="dialog-header">
      <div>
        <h2 class="dialog-title">View Note</h2>
        <!-- <p class="dialog-subtitle" *ngIf="caseTitle">{{ caseTitle }}</p> -->
      </div>
      <button type="button" class="dialog-close-btn" (click)="cancel()" aria-label="Close dialog">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="note-view-content">{{ viewContent }}</div>

    <div class="dialog-actions">
      <button type="button" class="btn-cancel" (click)="cancel()">Close</button>
    </div>
  </ng-container>

</div>